function pdTurnOnPleaseWaitAnimation(message = "Preparing Your Order...") {
	jQuery.blockUI({ css: {
            border: 'none',
            padding: '15px',
            backgroundColor: '#000',
            '-webkit-border-radius': '10px',
            '-moz-border-radius': '10px',
            opacity: .5,
            color: '#fff'
        },
        overlayCSS: { backgroundColor: '#fff', opacity: 0.8 },
        message: message
    });
}
function pdTurnOffPleaseWaitAnimation() {
	jQuery.unblockUI();
}

//*** start blocking animation
//pdTurnOnPleaseWaitAnimation();

//*** unblock (no matter what) after 5 seconds
setTimeout(pdTurnOffPleaseWaitAnimation, 5000);

function pdIsBlank(item) {
	item = String(item).toLowerCase();
	if (item == "undefined" || item == "" || item == "null") return true;
	else return false;
}

function pdCheckoutInit() {
	var page = "";
	try {page = document.forms["CheckoutForm"]["sectionId"].value;} catch(e) {}
	if(page == "") page = pdGetQueryString("sectionId");
	var jsonCart = "";if(typeof cart !== 'undefined') jsonCart = JSON.stringify(cart);
	var pdCartSessionId = pdGetCookie("pdCartSessionId");
	var pdId = "";
	var pdIdTemp = String(window.location.hash.substr(1));
	if(pdIdTemp.indexOf("pdId=") > -1) pdId= String(pdIdTemp).replace("pdId=", "");
	var scriptUrl = "https://myaccount.knifeart.com/mod_yahooCheckout/services/checkout.php";
	scriptUrl += "?page=" + encodeURIComponent(page);
	scriptUrl += "&pdCartSessionId=" + encodeURIComponent(pdCartSessionId);
	scriptUrl += "&yahooSessionCookie=" + encodeURIComponent(pdGetCookie("ysco_key_session_cookie"));
	scriptUrl += "&yahooShoppingCartCookie=" + encodeURIComponent(pdGetCookie("ysco_key_shopping_cart_cookie"));
	scriptUrl += "&yahooCouponValue=" + encodeURIComponent(pdGetYahooCouponValue());
	scriptUrl += "&yahooGiftWrapCharge=" + encodeURIComponent(pdGetGiftWrapCharge());
	try{scriptUrl += "&orderNum=" + encodeURIComponent(orderNum);} catch(e) {}
	if(pdId != "") scriptUrl += "&pdId=" + encodeURIComponent(pdId);

	// Facebook Conversion API parameters.
	const pd_fbc = pdGetCookie("pd_fbc");
	if (!pdIsBlank(pd_fbc)) {
		scriptUrl += "&pdFbcId=" + pd_fbc;
		if (pdIsBlank(pdFbEventId) == false) {
			scriptUrl += "&pdFbEventId=" + pdFbEventId;
		}
	}

	var postData = { cart: jsonCart };
	// var customerObj = getPdCustomerDataObject();
	if (typeof customerObj !== 'undefined') {
		postData.customer = JSON.stringify(customerObj);
	}

	jQuery.ajax({
		type: "POST",
		crossDomain: true,
		xhrFields: {
			withCredentials: true
		},
		url: scriptUrl,
		data: postData,
		dataType: "text script",
	});
}
function pdGetGiftWrapCharge() {
	var giftWrapCharge = false;
	jQuery("#ys_cart .ys_orderLine .ys_first").each(function(){
		var lineItemLabel = jQuery(this).text();
		if (lineItemLabel.indexOf("Gift Wrap") >= 0){
			try{
				giftWrapCharge = jQuery(this).next().text().replace(/[^0-9\.]/g, '');
			} catch(err) {}
		}
	});
	return giftWrapCharge;
}
var pdGetQueryString = function ( field, url ) {
    var href = url ? url : window.location.href;
    var reg = new RegExp( '[?&]' + field + '=([^&#]*)', 'i' );
    var string = reg.exec(href);
    return string ? string[1] : null;
};
function pdGetCookie(name) {
	var cookieValue = "";
	var value = "; " + document.cookie;
	var parts = value.split("; " + name + "=");
	if (parts.length == 2) cookieValue = parts.pop().split(";").shift();
	if(pdIsBlank(cookieValue)) cookieValue = "";
	return cookieValue;
}
function pdGetYahooCouponValue() {
	var couponValue = "0";
	return couponValue;
}
if ( window.name != "atcTarget" ) {
	pdCheckoutInit();
}
